module.exports = __webpack_public_path__ + "static/img/Opportunities_Visiting_Speakers_4.3592a98.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Opportunities_Visiting_Speakers_4.jpg
// module id = 70cR
// module chunks = 1